function closeStory(story, openStoryButton, webStoriesEmbed, closeElement) {
  openStoryButton.style.display = 'block';
  story.classList.remove('story-opened');
  webStoriesEmbed.removeChild(closeElement);
}


function openStory(story, openStoryButton) {
  const closeElement = document.createElement('button');
  const closeElementText = document.createElement('span');
  const webStoriesEmbed = story.querySelector('.wp-block-web-stories-embed');
  openStoryButton.style.display = 'none';
  closeElement.classList.add('article__close');
  closeElementText.classList.add('article__close-text');
  closeElementText.innerHTML = 'X';
  closeElement.appendChild(closeElementText);
  webStoriesEmbed.appendChild(closeElement);
  closeElement.addEventListener('click', () => {
    closeStory(story, openStoryButton, webStoriesEmbed, closeElement);
  });
  story.classList.add('story-opened');
}

// Adiciona um elemento e um click handler a este elemento para cada artigo
function enableWebStoriesHover() {
  const storySelector = '.article__body';
  const stories = document.querySelectorAll(storySelector);
  stories.forEach((story) => {
    const openStoryButton = document.createElement('button');
    openStoryButton.classList.add('article__button-open-story');
    story.appendChild(openStoryButton);
    openStoryButton.addEventListener('click', () => {
      openStory(story, openStoryButton);
    });
  });
}

const location = window.location.href;

// Ativa a função somente na página /web-stories
if (location.includes('/web-stories/')) window.onload = enableWebStoriesHover;
